import React from 'react'
import { Button, IconButton, Menu, MenuItem } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { NavLink } from 'react-router-dom'
import { formatRoute } from 'react-router-named-routes'
import { NamedRoutes } from '../../../../routes'
import { TableRowBackground } from '../../../../utils/colors'
import { useStyles } from './Styles'
import DeleteCategory from './DeleteCategory'

const CategoryMenu = ({ index, data, setData, count, setCount, handleNotificationCall }) => {
  let classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [viewPageMenu, setViewPageMenu] = React.useState(false)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setViewPageMenu(true)
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setViewPageMenu(false)
  }


  const StyledMenu = withStyles({
    paper: {
      border: `1px solid ${TableRowBackground}`
    }
  })((props) => (
    <Menu
      elevation={4}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      disableScrollLock
      {...props}
    />
  ))

  const [viewDeleteCategoryDialog, setViewDeleteCategoryDialog] = React.useState(false)
  const [openDeleteCategoryDialog, setOpenDeleteCategoryDialog] = React.useState(false)
  const handleDeleteCategoryDialog = () => {
    if (!openDeleteCategoryDialog) {
      setViewDeleteCategoryDialog(true)
    } else {
      setTimeout(() => setViewDeleteCategoryDialog(false), 500)
    }
    setOpenDeleteCategoryDialog(!openDeleteCategoryDialog)
  }

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon/>
      </IconButton>
      {!!viewPageMenu &&
      <StyledMenu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        className={classes.UserCustomMenu}
      >
        <MenuItem onClick={handleClose}>
          <NavLink to={formatRoute(NamedRoutes.subscription.category.edit, { id: data[index].id })}>
            <FormattedMessage id='UserMenu.editPage'/>
          </NavLink>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Button color="primary" onClick={handleDeleteCategoryDialog}>
            <FormattedMessage id='UserMenu.deletePage'/>
          </Button>
        </MenuItem>
      </StyledMenu>
      }
      <DeleteCategory
        index={index}
        data={data}
        setData={setData}
        count={count}
        setCount={setCount}
        handleNotificationCall={handleNotificationCall}
        handleDeleteCategoryDialog={handleDeleteCategoryDialog}
        viewDeleteCategoryDialog={viewDeleteCategoryDialog}
        openDeleteCategoryDialog={openDeleteCategoryDialog}/>
    </div>
  )
}

export default CategoryMenu
